var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1CCEDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5194 6.69053C17.0822 6.31599 16.4199 6.38696 16.072 6.84561L10.4295 14.2848L7.42139 11.2789C7.03083 10.8886 6.39786 10.8887 6.00743 11.2792L5.70711 11.5795C5.31658 11.97 5.31658 12.6032 5.70711 12.9937L9.91244 17.199C10.3377 17.6244 11.0396 17.5807 11.4089 17.1059L18.1287 8.46712C18.4565 8.0457 18.3954 7.4411 17.99 7.09374L17.5194 6.69053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circleTick.5e9b15f342d4e53251d314c682ab111b.svg";
export { ForwardRef as ReactComponent };